module.exports = __webpack_public_path__ + "media/images/temp/images-3db4c916ae4d345310a0accc31b84ddb.png";